import {createContext, useContext, useState} from "react";
import {initStructure} from "../utils/initStructure";
import {requestAccessObj} from "../utils/constants";


const AppContext = createContext({
    row: null,
    documentTypes: [],
    brands: [],
    periods: [],
    countries: [],
    advertiseResources: [],
    department: [],
    users: [],
    mode: "",
    tab: "",
    docCount: null,
    dataLoading: true,
    documents: [],
    activePage: 1,
    limit: 30,
    reloadButton: false,
    draftNewDocument: false,
    newRowLoad: false,
    initialRow: null,
    changed: false,
    history: [],
    open: false,
    isForbidden: false,
    requestAccessData: null,
    accessResponses: [],
    needAccess: [],
});

export function AppProvider({children}) {
    const [row, setRow] = useState(initStructure)
    const [documentTypes, setDocumentTypes] = useState([])
    const [brands, setBrands] = useState([])
    const [periods, setPeriods] = useState([])
    const [countries, setCountries] = useState([])
    const [advertiseResources, setAdvertiseResources] = useState([])
    const [department, setDepartment] = useState([])
    const [users, setUsers] = useState([]);
    const [mode, setMode] = useState("editDocument")
    const [tab, setTab] = useState('info')
    const [docCount, setDocCount] = useState(null)
    const [dataLoading, setDataLoading] = useState(true)
    const [documents, setDocuments] = useState([])
    const [activePage, setActivePage] = useState(1);
    const [limit, setLimit] = useState(30);
    const [reloadButton, setReloadButton] = useState(false)
    const [draftNewDocument, setDraftNewDocument] = useState(JSON.parse(localStorage.getItem("draftNewDocument")) || false)
    const [newRowLoad, setNewRoadLoad] = useState(false)
    const [initialRow, setInitialRow] = useState(null);
    const [changed, setChanged] = useState(false);
    const [history, setHistory] = useState([]);
    const [requestAccessData, setRequestAccessData] = useState(requestAccessObj);
    const [open, setOpen] = useState(false);
    const [isForbidden, setIsForbidden] = useState(false)
    const [accessResponses, setAccessResponses] = useState([])
    const [needAccess, setNeedAccess] = useState([])

    return (
        <AppContext.Provider value={{
            row,
            setRow,
            documentTypes,
            setDocumentTypes,
            brands,
            setBrands,
            periods,
            setPeriods,
            countries,
            setCountries,
            advertiseResources,
            setAdvertiseResources,
            department,
            setDepartment,
            users,
            setUsers,
            mode,
            setMode,
            tab,
            setTab,
            docCount,
            setDocCount,
            dataLoading,
            setDataLoading,
            documents,
            setDocuments,
            activePage,
            setActivePage,
            limit,
            setLimit,
            reloadButton,
            setReloadButton,
            draftNewDocument,
            setDraftNewDocument,
            newRowLoad, setNewRoadLoad,
            initialRow, setInitialRow,
            changed, setChanged,
            history, setHistory,
            open, setOpen,
            isForbidden, setIsForbidden,
            requestAccessData, setRequestAccessData,
            accessResponses, setAccessResponses,
            needAccess, setNeedAccess,

        }}
        >
            {children}
        </AppContext.Provider>
    )
}

export const useStore = () => useContext(AppContext)